import React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import { SunLifeProposalFormDelegate } from 'store/modules/initiate-proposal/sunLife/proposalFormDelegate';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from '../styles';
import { AlertStyled, SICWrapperStyled } from './styles';
import { SUN_LIFE_INITIATE_PROPOSAL_FORM_ID, SUN_LIFE_SIC_WARNING_ALERT_TEST_ID } from '../constants';
import DomainProductLines from '../DomainProductLines';

interface Props {
  proposalFormDelegate: SunLifeProposalFormDelegate;
}

const SunLifeInitiateProposalForm: React.FC<Props> = observer(({ proposalFormDelegate }) => {
  const {
    proposalForm,
    effectiveDatesOptions,
    availableProductLineItems,
    isAvailableProductLinesLoading,
    sicWarningMessage,
  } = proposalFormDelegate;

  const showWarning = Boolean(sicWarningMessage);

  return (
    <IMFormStyled id={SUN_LIFE_INITIATE_PROPOSAL_FORM_ID} formController={proposalForm}>
      <SectionTitle text="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled text="Additional Information" />
      <IMInputText label="Estimated Number of Eligible Employees" name="groupSize" size="full" />
      <SICWrapperStyled>
        <IMSicSearch label="SIC Code" size="full" />
        <Collapse show={showWarning}>
          <AlertStyled
            content={[sicWarningMessage]}
            title="Note"
            type="warning"
            data-test-id={SUN_LIFE_SIC_WARNING_ALERT_TEST_ID}
          />
        </Collapse>
      </SICWrapperStyled>

      <FollowingSectionTitleStyled text="Available Product Lines" />
      <DomainProductLines
        domainProductLineItems={availableProductLineItems}
        isLoading={isAvailableProductLinesLoading}
      />
    </IMFormStyled>
  );
});

export default SunLifeInitiateProposalForm;
